<template>
  <div>
    <PSkeleton :class="`heading-skeleton-${size}`" height="" :width="width" />
  </div>
</template>

<script setup lang="ts">
import PSkeleton from "@/atoms/PSkeleton.vue";

defineProps<{
  size: "1" | "2" | "3" | "4";
  width: string;
}>();
</script>

<style lang="postcss">
/*
 * Heights and margins derived from STextSkeleton's fontSize→lineHeight map.
 * height = fontSize, margin-top = (lineHeight - fontSize) / 2,
 * margin-bottom = (lineHeight - fontSize) / 2 + heading margin (mb-3/mb-2/mb-1).
 */
.heading-skeleton {
  &-1 {
    /* 2xl: 1.5/2, margin 0.25, heading mb-3 (0.75) */
    height: 1.5rem;
    margin-top: 0.25rem;
    margin-bottom: 1rem;

    @screen 600 {
      /* 4xl: 2.25/2.5875 */
      height: 2.25rem;
      margin-top: 0.1688rem;
      margin-bottom: 0.9187rem;
    }

    @screen 800 {
      /* 5xl: 3/3.3 */
      height: 3rem;
      margin-top: 0.15rem;
      margin-bottom: 0.9rem;
    }

    @screen 1000 {
      /* 6xl: 3.75/3.75 */
      height: 3.75rem;
      margin-top: 0;
      margin-bottom: 0.75rem;
    }
  }

  &-2 {
    /* xl: 1.25/1.75, margin 0.25, heading mb-2 (0.5) */
    height: 1.25rem;
    margin-top: 0.25rem;
    margin-bottom: 0.75rem;

    @screen 600 {
      /* 2xl: 1.5/2 */
      height: 1.5rem;
      margin-top: 0.25rem;
      margin-bottom: 0.75rem;
    }

    @screen 800 {
      /* 3xl: 1.875/2.34375 */
      height: 1.875rem;
      margin-top: 0.2344rem;
      margin-bottom: 0.7344rem;
    }
  }

  &-3 {
    /* lg: 1.125/1.75, margin 0.3125, heading mb-2 (0.5) */
    height: 1.125rem;
    margin-top: 0.3125rem;
    margin-bottom: 0.8125rem;

    @screen 600 {
      /* xl: 1.25/1.75 */
      height: 1.25rem;
      margin-top: 0.25rem;
      margin-bottom: 0.75rem;
    }

    @screen 800 {
      /* 2xl: 1.5/2 */
      height: 1.5rem;
      margin-top: 0.25rem;
      margin-bottom: 0.75rem;
    }
  }

  &-4 {
    /* base: 1/1.5, margin 0.25, heading mb-1 (0.25) */
    height: 1rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;

    @screen 600 {
      /* lg: 1.125/1.75 */
      height: 1.125rem;
      margin-top: 0.3125rem;
      margin-bottom: 0.5625rem;
    }

    @screen 800 {
      /* xl: 1.25/1.75 */
      height: 1.25rem;
      margin-top: 0.25rem;
      margin-bottom: 0.5rem;
    }
  }
}
</style>
